<template>
  <div>
    Profile 1
  </div>
  <div>
    Profile 2
  </div>
</template>
